module.exports = __webpack_public_path__ + "static/img/user.a91c98e.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/users/user.png
// module id = 4
// module chunks = 13